/**
 * upsell-drawer.js
 * Add-to-cart para el widget de upsell en el cart drawer.
 * Usa el evento cart:refresh de Prestige para re-renderizar el drawer.
 */

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-upsell-variant]');
  if (!btn) return;

  const variantId = parseInt(btn.dataset.upsellVariant, 10);
  if (!variantId) return;

  const btnText = btn.querySelector('span');
  btn.disabled = true;
  if (btnText) btnText.textContent = '...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });

    if (!res.ok) throw new Error('cart_add_failed');

    // Prestige escucha cart:refresh en document para re-renderizar el drawer
    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch {
    btn.disabled = false;
    if (btnText) btnText.textContent = 'Agregar';
  }
});
